module.exports = __webpack_public_path__ + "static/media/gh.8d6cfc3e.png";